import { createServerFn } from "@tanstack/react-start";

import { type DashboardBanner, dashboardBanners } from "./dashboardBanners";
import { localDashboardBanners } from "./localDashboardBanners";

/**
 * Every published dashboard banner, for the dashboard. The browser never reads
 * Sanity itself; an empty list when the CMS cannot be read. Outside
 * production a developer's local banners come first.
 */
export const dashboardBannersCms = createServerFn({ method: "GET" }).handler(
  async (): Promise<DashboardBanner[]> => [
    ...(await localDashboardBanners()),
    ...(await dashboardBanners()),
  ]
);
